import {PageHeader} from '../index';
import React from 'react';

export default function MyDashboardPageHeader () {
  return (
    <PageHeader title='My Dashboard' height='119px' />
  );
}